import React from 'react';
import { motion } from 'framer-motion';
import { RADIUS } from '../../../config/designTokens';
import { RARITY_CONFIG } from '../../../mascot/achievements/achievementData';
import { GoldenShimmer, LegendaryGlow } from './effects';
import { useAchievementShimmer } from './useAchievementShimmer';
import { AchievementProgressBar } from './AchievementProgressBar';
import type { AchievementCardProps } from './types';
export function CompactAchievementCard({
  achievement,
  isUnlocked,
  index,
  showEffects
}: AchievementCardProps & {
  showEffects: boolean;
}) {
  const isNewlySeen = useAchievementShimmer(achievement.id, isUnlocked);
  const config = RARITY_CONFIG[achievement.rarity];
  const isHighlightRarity = achievement.rarity === 'rare' || achievement.rarity === 'legendary';
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    delay: index * 0.1
  }} className={`relative flex items-center gap-3 p-3 ${RADIUS.card} border-2 transition-all ${isUnlocked ? `${config.cardBg} ${config.cardBorder} ${showEffects && isHighlightRarity ? `shadow-md ${config.glowColor}` : 'shadow-sm'}` : 'bg-slate-50 border-slate-200 opacity-80'} ${isNewlySeen ? 'animate-shine' : ''}`} style={isNewlySeen ? {
    animationIterationCount: 1
  } : undefined} data-id="element-1776">
      {isUnlocked && showEffects && achievement.rarity === 'legendary' && <LegendaryGlow data-id="element-1777" />}
      {isUnlocked && showEffects && achievement.rarity === 'rare' && <GoldenShimmer data-id="element-1778" />}

      <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white/50 rounded-xl" data-id="element-1779">
        <span className="text-2xl" data-id="element-1780">{achievement.emoji}</span>
      </div>

      <div className="flex-1 min-w-0" data-id="element-1781">
        <div className="flex items-center justify-between gap-2 mb-1" data-id="element-1782">
          <h4 className={`font-bold text-sm truncate ${isUnlocked ? 'text-slate-800' : 'text-slate-600'}`} data-id="element-1783">
            {achievement.name}
          </h4>
          {isUnlocked && isHighlightRarity && <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-[9px] font-bold ${config.badgeBg} ${config.badgeText}`} data-id="element-1784">
              {config.label}
            </span>}
        </div>

        {!isUnlocked && achievement.progress ? <AchievementProgressBar current={achievement.progress.current} max={achievement.progress.max} label={achievement.description} data-id="element-1785" /> : <p className={`text-xs truncate ${isUnlocked ? config.textColor : 'text-slate-500'}`} data-id="element-1786">
            {achievement.description}
          </p>}
      </div>
    </motion.div>;
}